import founderImage from "@/assets/gurkan-sonmez.jpg";

export interface Author {
  id: string;
  slug: string;
  name: string;
  title: string;
  role: string;
  bio: string;
  expertiseAreas: string[];
  whatsapp: string;
  email: string;
  image: string;
}

export const AUTHORS: Record<string, Author> = {
  "gurkan-sonmez": {
    id: "1",
    slug: "gurkan-sonmez",
    name: "Gürkan Sönmez",
    title: "Gayrimenkul Danışmanı & Kurucu",
    role: "Adana Seyhan & Çukurova Bölge Uzmanı",
    bio: "Gürkan Sönmez, Adana gayrimenkul piyasasında uzun yıllara dayanan saha tecrübesiyle Gürselpaşa, Pınar, Güzelyalı ve Mahfesığmaz bölgelerinde konut, arsa ve ticari gayrimenkul yatırım danışmanlığı sunmaktadır.",
    expertiseAreas: [
      "Gürselpaşa Satılık Daireler",
      "Çukurova Göl Manzaralı Villalar",
      "Gayrimenkul Değerleme & Ekspertiz",
      "Konut Yatırım Analizi"
    ],
    whatsapp: "905335487801",
    email: "info@cornergayrimenkul.com.tr",
    image: founderImage
  },
  "corner-analiz-ekibi": {
    id: "2",
    slug: "corner-analiz-ekibi",
    name: "Corner Gayrimenkul",
    title: "Gayrimenkul Rehberleri",
    role: "Adana Gayrimenkul Piyasa Araştırmaları",
    bio: "Adana genelinde gayrimenkul arayışına yardımcı olan, resmî kaynak bağlantıları içeren mülk kontrol ve bölge rehberleri.",
    expertiseAreas: [
      "Adana Konut Fiyat Endeksi",
      "Mahalle Bazlı Amortisman Süreleri",
      "Ticari Mülk Verimliliği"
    ],
    whatsapp: "905335487801",
    email: "info@cornergayrimenkul.com.tr",
    image: "/placeholder.svg"
  }
};
